import { Prices } from '@/store/prices/types';

import { STRIPE_ZERO_DECIMAL_CURRENCIES } from './constants';

export type PriceCatalogResponse = {
	currency: string;
	price: number;
	original_price?: number;
	original_tiered_price?: number;
};

export const mergeCatalogPriceIntoPrices = (
	priceCatalog: PriceCatalogResponse,
	prices: Prices | null,
	priceKey: string,
) => {
	// A falsy `prices` means the sub-prices fetch itself returned an empty body — nothing to
	// merge into, so degrade to the fetch's own null rather than crash on `prices.current`.
	if (!prices) {
		return null;
	}

	// no valid family plan price if the currency doesn't match
	if (priceCatalog.currency.toLowerCase() !== prices.current.currency.toLowerCase()) {
		return prices;
	}

	const price = STRIPE_ZERO_DECIMAL_CURRENCIES.has(priceCatalog.currency.toLowerCase())
		? priceCatalog.price * 100
		: priceCatalog.price;

	return {
		...prices,
		original: {
			...prices.original,
			[priceKey]: price,
		},
		current: {
			...prices.current,
			[priceKey]: price,
		},
	};
};
